/**
 * @constructor
 * @param {Foundation.Form} form
 * @implements {Foundation.Form.Validator}
 */
Foundation.Form.Validator.Email = function (/* form */) {};

Foundation.Form.Validator.Email.prototype.identifier = function () {
     return "email";
};

/**
 * @param {jQuery} fieldElements
 * @return {Foundation.Promise}
 */
Foundation.Form.Validator.Email.prototype.validate = function (fieldElements) {
    var result = new Foundation.Promise();
    var errorArray = [];
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    fieldElements.each(function (i, element) {
        element = jQuery(element);
        var emailAddr = element.val();
        if (emailAddr && !emailAddr.trim().match(regex)) {
            errorArray.push({
                "message": "Please enter a valid email address.",
                "fields": element.attr("name")
            });
        }
    });

    if (errorArray.length) {
        result.set("errors", errorArray);
        result.fail();
    }
    else {
        result.fulfill();
    }

    return result;
};

Foundation.Form.registerValidator(Foundation.Form.Validator.Email);
